import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-rounded-arrow-right",
  "use": "tamr-icon-rounded-arrow-right-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-rounded-arrow-right\"><path d=\"M9.5,6.2l13,8.1a1,1,0,0,1,0,1.6l-13,8.9A1,1,0,0,1,8,24V7A1,1,0,0,1,9.5,6.2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol